
import * as React from 'react'
import { MenuItem } from './wrapper' // Central type definition

// Define a mapping for the components to be rendered
export const componentMapping = {
  // Dropdown components will be passed here by GenieDropdown
  // ContextMenu components will be passed here by GenieContextMenu
}

// This is a generic renderer. It receives the components it needs to render as an argument.
interface MenuComponents {
  DropdownMenuItem: React.ComponentType<{
    key?: string
    disabled?: boolean
    onClick?: () => void
    variant?: 'default' | 'danger'
    children: React.ReactNode
  }>
  DropdownMenuSeparator: React.ComponentType<{ key?: string }>
  DropdownMenuLabel: React.ComponentType<{
    key?: string
    children: React.ReactNode
  }>
  DropdownMenuGroup: React.ComponentType<{ children: React.ReactNode }>
  DropdownMenuShortcut?: React.ComponentType<{ children: React.ReactNode }>
  DropdownMenuSub?: React.ComponentType<{
    key?: string
    children: React.ReactNode
  }>
  DropdownMenuSubTrigger?: React.ComponentType<{ children: React.ReactNode }>
  DropdownMenuSubContent?: React.ComponentType<{ children: React.ReactNode }>
}

export const renderMenuItems = (
  items: MenuItem[],
  components: MenuComponents
) => {
  return items.map((item, index) => {
    const key = `${item.type}-${'label' in item ? item.label.replace(/\s+/g, '-') : ''}-${index}`

    switch (item.type) {
      case 'item':
        return (
          <components.DropdownMenuItem
            key={key}
            disabled={item.disabled}
            onClick={item.onClick}
            variant={item.variant} // Pass variant prop
          >
            {item.icon && (
              <span className="flex items-center justify-center -mt-px">
                {item.icon}
              </span>
            )}
            <span className="flex-grow">{item.label}</span>
            {item.shortcut && components.DropdownMenuShortcut && (
              <components.DropdownMenuShortcut>
                {item.shortcut}
              </components.DropdownMenuShortcut>
            )}
          </components.DropdownMenuItem>
        )
      case 'separator':
        return <components.DropdownMenuSeparator key={key} />
      case 'label':
        return (
          <components.DropdownMenuLabel key={key}>
            {item.label}
          </components.DropdownMenuLabel>
        )
      case 'submenu':
        if (
          components.DropdownMenuSub &&
          components.DropdownMenuSubTrigger &&
          components.DropdownMenuSubContent
        ) {
          return (
            <components.DropdownMenuSub key={key}>
              <components.DropdownMenuSubTrigger>
                {item.label}
              </components.DropdownMenuSubTrigger>
              <components.DropdownMenuSubContent>
                {renderMenuItems(item.items, components)}
              </components.DropdownMenuSubContent>
            </components.DropdownMenuSub>
          )
        }
        return null
      default:
        return null
    }
  })
}
